import { View, Text } from "react-native";
import React, { useEffect, useState } from "react";
import { primary } from "../../colors";
import MyText from "./MyText";
import MyInputWithLabel from "./MyInputWithLabel";
import Checkbox from "expo-checkbox";

export default function SupportTimeItem({ day, time, setTime }) {
  const [isChecked, setChecked] = useState(time === null || time === undefined);
  let startTime = "";
  let endTime = "";
  const [timeState, setTimeState] = useState({ start: "", end: "" });

  if (time !== undefined && time !== null) {
    startTime = time.split(" - ")[0];
    endTime = time.split(" - ")[1];
  } else {
  }

  useEffect(() => {
    if (isChecked) {
      if (setTime !== undefined) {
        setTime((prev) => {
          let newObj = prev;
          newObj[day] = { start: null, end: null };
          return { ...newObj };
        });
      }
    } else {
      if (setTime !== undefined) {
        setTime((prev) => {
          let newObj = prev;
          if (timeState.start.length === 0 || timeState.end.length === 0) {
            newObj[day] = { start: null, end: null };
          } else {
            newObj[day] = { start: timeState.start, end: timeState.end };
          }

          return { ...newObj };
        });
      }
    }
  }, [isChecked, timeState]);

  return (
    <View
      style={{
        width: "95%",
        backgroundColor: "#f8f8f8",
        padding: 10,
        marginVertical: 10,
        borderRadius: 10,
        borderWidth: 1,
        borderColor: primary,
      }}
    >
      <View
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "row",
          marginTop: -11,
        }}
      >
        <View
          style={{
            borderWidth: 1,
            borderRadius: 10,
            padding: 5,
            borderColor: primary,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            marginHorizontal: 10,
            minWidth: 100,
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: primary,
          }}
        >
          <MyText style={{ color: "white" }}>{day}</MyText>
        </View>
      </View>
      <View style={{ marginTop: 10 }}>
        <View style={{ flexDirection: "row", alignItems: "center" }}>
          <Checkbox
            value={isChecked}
            onValueChange={setChecked}
            color={isChecked ? primary : undefined}
          />
          <MyText style={{ marginHorizontal: 5 }}>
            عدم پاسخ دهی در این روز
          </MyText>
        </View>
      </View>
      <View style={{ flexDirection: "row", zIndex: 1 }}>
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            opacity: isChecked ? 0.5 : 1,
          }}
        >
          <MyText>از ساعت</MyText>
          <View style={{ width: 80, marginHorizontal: 10 }}>
            <MyInputWithLabel
              name="start"
              disabled={isChecked}
              value={startTime}
              setInput={setTimeState}
              keyboardType="number-pad"
            />
          </View>
        </View>
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            opacity: isChecked ? 0.5 : 1,
          }}
        >
          <MyText>تا ساعت</MyText>
          <View style={{ width: 80, marginHorizontal: 10 }}>
            <MyInputWithLabel
              keyboardType="number-pad"
              name="end"
              disabled={isChecked}
              value={endTime}
              setInput={setTimeState}
            />
          </View>
        </View>
      </View>
    </View>
  );
}
